export function getDefaultControls(): string[] {
  return ['ZOOM', 'ATTRIBUTION'];
}
